interface TabConfig<T extends string> {
  key: T;
  label: string;
}

interface TabSelectorProps<T extends string> {
  selectedTab: T;
  setSelectedTab: (tab: T) => void;
  tabsConfig: TabConfig<T>[];
  justifyContent?: 'justify-between' | 'justify-start' | 'justify-center';
  gap?: string;
  inActiveClassName?: string;
  tabsOptionsClassName?: string;
}

const TabSelector = <T extends string>({
  selectedTab,
  setSelectedTab,
  tabsConfig,
  justifyContent = 'justify-between',
  gap = '',
  inActiveClassName = 'text-gray-500 border-b-2 border-transparent',
  tabsOptionsClassName = 'text-sm font-medium',
}: TabSelectorProps<T>) => (
  <div
    className={`flex items-center ${gap} ${justifyContent} w-full ${tabsOptionsClassName}`}
  >
    {tabsConfig.map(tab => {
      const isActive = selectedTab === tab.key;
      return (
        <div
          key={tab.key}
          className={`cursor-pointer py-2 mb-1 ${
            isActive
              ? 'text-farm-shop-500 border-b-2 border-farm-shop-400'
              : inActiveClassName
          }`}
          onClick={() => setSelectedTab(tab.key)}
        >
          {tab.label}
        </div>
      );
    })}
  </div>
);

export default TabSelector;
